import Typography from '@mui/material/Typography'

export default function Error({ errorMsg, marginTop = '1px', color = 'red' }) {
  return (
    <Typography
      variant='p'
      style={{
        fontWeight: 400,
        marginTop,
        paddingLeft: 2,
        fontSize: '14px',
        color,
        textAlign: 'left'
      }}
    >
      {errorMsg}
    </Typography>
  )
}
